import React from 'react';
import Button from 'react-bootstrap/Button';
import { Form } from 'react-bootstrap';
import { FaStar, FaPlay, FaUndo } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

// Bootstrap's `svg { vertical-align: middle }` drops these icons below the text baseline.
const ICON_STYLE = { verticalAlign: '-0.125em' };

const RecentSearchItemDesktop = ({
  search,
  idx,
  onResumeSearch,
  onStartOverSearch,
  onToggleSubscription,
  getLocationName,
  formatDate,
  getResidencyFlag,
  showToggle = false,
  updating = false,
  isCurrentSearch = false,
  canStartOver = true
}) => {
  const { t, i18n } = useTranslation();
  const rtl = i18n.dir() === 'rtl';

  if (!search || !search.params) return null;

  const { params, savedOffers = [], timestamp } = search;
  const fromLocationName = getLocationName(params?.fromLocationCode);
  const toLocationName = getLocationName(params?.toLocationCode);
  const sameLocations = fromLocationName === toLocationName;
  const age = params?.age ? Number(params.age) : null;
  const hasSavedOffers = savedOffers && savedOffers.length > 0;

  return (
    <div
      key={search.searchKey || `search-${idx}`}
      className="card mb-3"
      style={{ direction: rtl ? 'rtl' : 'ltr' }}
    >
      <div className="card-body p-3">
        <div className="flex-grow-1" style={{ textAlign: rtl ? 'right' : 'left' }}>
          <div className="d-flex align-items-center mb-1">
            <span>
              <b>{fromLocationName}</b>
              {!sameLocations && (
                <>
                  {rtl ? ' ← ' : ' → '}
                  <b>{toLocationName}</b>
                </>
              )}
            </span>
            {hasSavedOffers && (
              <FaStar
                className={`text-warning ${rtl ? 'mr-2' : 'ml-2'}`}
                size="16"
                title={`${t('savedOffers')}: ${savedOffers.length}`}
              />
            )}
          </div>
          <div style={{ fontSize: '0.9em', color: '#666' }}>
            {formatDate(params?.startDate)} - {formatDate(params?.endDate)}
          </div>
          {(age !== null || params?.residency || params?.cur) && (
            <div style={{ fontSize: '0.8em', color: '#888', marginTop: '2px' }}>
              {age !== null && <span>{t('driverAgeText')}: {age === 30 ? '30-65' : age}</span>}
              {age !== null && (params?.residency || params?.cur) && <span> • </span>}
              {params?.residency && <span>{t('residency')}: {getResidencyFlag(params.residency)}</span>}
              {params?.residency && params?.cur && <span> • </span>}
              {params?.cur && <span>{t('selectCurrency')}: {params.cur}</span>}
            </div>
          )}
          {timestamp && (
            <div style={{ fontSize: '0.8em', color: '#999' }}>
              {t('searchedOn', 'Searched on')} {formatDate(timestamp)}
            </div>
          )}
        </div>
        <div className="mt-2 d-flex justify-content-end">
          {showToggle ? (
            <Form.Check
              type="switch"
              id={`subscription-${search.searchKey || idx}`}
              label={t('subscriptions.email_notifications')}
              checked={!search.optOut}
              onChange={(e) => onToggleSubscription(search.searchKey, !e.target.checked)}
              disabled={updating}
            />
          ) : isCurrentSearch ? (
            <>
              <span className="text-muted font-weight-bold" style={{ minWidth: 120, textAlign: 'center' }}>
                {t('currentSearch')}
              </span>
              {canStartOver && (
                <div className={`text-center ${rtl ? 'mr-2' : 'ml-2'}`}>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => onStartOverSearch(params)}
                    style={{ minWidth: 120, textAlign: 'center' }}
                  >
                    <FaUndo className={rtl ? 'ml-1' : 'mr-1'} style={ICON_STYLE} />{t('startOver')}
                  </Button>
                  <div style={{ fontSize: '0.8em', color: '#888' }}>{t('startOverHint')}</div>
                </div>
              )}
            </>
          ) : (
            <>
              <div className="text-center">
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() => onResumeSearch(params, search.filters)}
                  style={{ minWidth: 120, textAlign: 'center' }}
                >
                  <FaPlay className={rtl ? 'ml-1' : 'mr-1'} style={ICON_STYLE} />{t('resumeSearch')}
                </Button>
                <div style={{ fontSize: '0.8em', color: '#888' }}>{t('resumeSearchHint')}</div>
              </div>
              <div className={`text-center ${rtl ? 'mr-2' : 'ml-2'}`}>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => onStartOverSearch(params)}
                  style={{ minWidth: 120, textAlign: 'center' }}
                >
                  <FaUndo className={rtl ? 'ml-1' : 'mr-1'} style={ICON_STYLE} />{t('startOver')}
                </Button>
                <div style={{ fontSize: '0.8em', color: '#888' }}>{t('startOverHint')}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentSearchItemDesktop;